'use strict';

const template = require('../../templates/companies/Company.ejs');

module.exports = Backbone.View.extend({
    tagName: 'tr',
    events: {
        'click .js-login-to-company': 'loginToCompany'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            attachments: null
        });
        this.model.on('sync', this.render, this);

        return this.render();
    },

    render: function() {
        this.$el.html(template({
            model:      this.model
        }));

        return this;
    },

    loginToCompany: function() {
        window.open(`/?company=${this.model.id}`, '_blank');
        return false;
    }
});



// WEBPACK FOOTER //
// ./app/mpp/views/companies/Company.js